import {
  CoveragePlanCard,
  CoveragePlanCardUrl,
  CoveragePlanType
} from '@cms-max/medicare-api-sdk'
import { parse } from 'date-fns'
import { useMemo } from 'react'

type OmCombined = {
  partAEffectiveDate: string
  partBEffectiveDate: string
  urls: Array<CoveragePlanCardUrl>
}

const ineligibleTypes = [
  CoveragePlanType.Ma,
  CoveragePlanType.Mapd,
  CoveragePlanType.Pbid
]

type useCombinedPartAPartBArgs = {
  plans?: Array<CoveragePlanCard>
}
export function useCombinedPartAPartB ({ plans }: useCombinedPartAPartBArgs) {
  return useMemo(() => {
    if (!plans?.length) return null

    const combined: OmCombined = {
      partAEffectiveDate: '',
      partBEffectiveDate: '',
      urls: []
    }

    for (const plan of plans) {
      // If the user has an MA or PBID plan, we won't be returning a combined OM card at all
      if (ineligibleTypes.includes(plan.type)) return null

      // enrollment_effective_date comes in as ISO8601 YYYY-MM-DD
      const enrollentDate = parse(
        plan.enrollment_effective_date,
        'yyyy-MM-dd',
        new Date()
      )
      if (plan.type === CoveragePlanType.OmPartA) {
        combined.partAEffectiveDate = new Intl.DateTimeFormat('en-US').format(
          enrollentDate
        )
      }

      if (plan.type === CoveragePlanType.OmPartB) {
        combined.partBEffectiveDate = new Intl.DateTimeFormat('en-US').format(
          enrollentDate
        )
      }

      // The URLs will be the same for both Part A & Part B, so just set from last
      if (
        [CoveragePlanType.OmPartA, CoveragePlanType.OmPartB].includes(plan.type)
      ) {
        combined.urls = plan.urls
      }
    }

    // Only return combined obj if we had both Part A & Part B
    if (!(combined.partAEffectiveDate && combined.partBEffectiveDate)) {
      return null
    }

    return combined
  }, [plans])
}
